import { createPostAsyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityMonitorsAllSlice } from '../all/get';
import { getCoreDataSecurityMonitorsByApplicationSlice } from '../application/get';
import { getCoreDataSecurityMonitorsSlice } from '../get';
import { subscribeDataSecurityMonitorById } from '@api/data-security';

export const subscribeCoreDataSecurityMonitorByIdSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [
			getCoreDataSecurityMonitorsSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitors,
			getCoreDataSecurityMonitorsAllSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitorsAll,
			getCoreDataSecurityMonitorsByApplicationSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitorsByApplication
		]
	},
	name: 'SubscribeCoreDataSecurityMonitorsById',
	receive: false,
	request: true,
	requestHandler: subscribeDataSecurityMonitorById
});
